import { createSlice } from '@reduxjs/toolkit'

import { DEFAULT_ISO_LANGUAGE_CODE } from '@marketplace-web/shared/i18n'

import { stateName } from './constants'
import { State } from './types'

export const initialState: State = {
  countryCode: '',
  user: null,
  anon_id: '',
  tracking_platform: 'web',
  tracker_debug_pin: null,
  languageCode: DEFAULT_ISO_LANGUAGE_CODE,
  facebookAppId: '',
  googleClientId: '',
  appleClientId: '',
  braze: {
    sdkKey: '',
    apiKey: '',
    safariWebsitePushId: '',
    sdkEndpoint: '',
  },
  isSmartAdServerAvailable: false,
  isWebView: false,
  isContentOnlyView: false,
}

const userSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {},
})

export const plug = { [stateName]: userSlice.reducer }
export default userSlice.reducer
